import {getGridBaseScene, getGridBackgroundScene} from "./default-resources";
import {type QueryClient} from "@tanstack/react-query";
import {API} from "../api";
import {resolveBannerSelection} from "../data/template-availability";
import {gridBackgroundQueryOptions} from "./background-catalog";
import {type LegacyScene} from "./legacy";
import {type CreateBannerInput, type DefaultOverride, type DefaultResources} from "./defaults";
import {object} from "./schema";

export function createGridResources(client: QueryClient): DefaultResources {
  const getScene = (sceneId: string) => client.fetchQuery({
    queryKey: ["grid-default-scene", sceneId], staleTime: Infinity,
    queryFn: async () => object(await API.fetchScene(sceneId), `scene.${sceneId}`),
  });
  return {
    getOverrides: (channel) => client.fetchQuery({
      queryKey: ["default-scene-overrides", channel], staleTime: Infinity,
      queryFn: async () => {
        const result = await API.getDefaultScenes(channel);
        if (result?.unsupported === true) throw new Error("The selected resource service does not support default scenes");
        if (!Array.isArray(result?.overrides)) throw new Error("Invalid defaults response: overrides missing");
        return result as {overrides: DefaultOverride[]};
      },
    }).then((result) => {
      // The existing hook caches the API envelope under the same key.
      const rows = result.overrides;
      if (!Array.isArray(rows)) throw new Error("Invalid cached defaults");
      return rows;
    }),
    getScene,
    getBaseScene: getGridBaseScene,
    getBackgroundScene: (input) => loadBackgroundScene(client, input),
  };
}

export function loadBackgroundScene(client: QueryClient, input: CreateBannerInput) {
  return getGridBackgroundScene(input, async (channel, type, product) => (await client.fetchQuery(gridBackgroundQueryOptions(channel, type, product))).backgrounds);
}
export function defaultInput(selection: {templateKey: string; product: string; contentType: string; set: string | null}): CreateBannerInput {
  const {layouts} = resolveBannerSelection(selection);
  return {...selection, instanceId: `banner-${crypto.randomUUID()}`, layout: layouts[0], background: "1"};
}
